<template>
    
    <div class="search-top-container">
        
        <STMap />

        <div class="search-top-btn-group">

            <div 
                v-for="option in options"
                :key="option.name"
                @click="handleOptionClick(option)"
            >

                <img 
                    :src="option.isSelected? option.imgs.selected : option.imgs.normal" 
                    class="search-top-btn" 
                />
            </div>
        </div>

        <STTable v-if="tOption && [1, 2, 3].includes(tOption.type)" />
    </div>
</template>

<script>

    import { mapMutations, mapState } from "vuex";

    import STTable from "@/components/STTable";
    import STMap from "@/components/STMap";

    import ImageArea from "@/assets/images/search/area.png";
    import ImageAreaSelected from "@/assets/images/search/area-selected.png";
    import ImagePlatform from "@/assets/images/search/platform.png";
    import ImagePlatformSelected from "@/assets/images/search/platform-selected.png";
    import ImageEnterprise from "@/assets/images/search/enterprise.png";
    import ImageEnterpriseSelected from "@/assets/images/search/enterprise-selected.png";
    // import ImageDevAxis from "@/assets/images/search/dev-axis.png";
    // import ImageDevAxisSelected from "@/assets/images/search/dev-axis-selected.png";

    export default {
        name: "SearchTop",
        components: {
            STTable,
            STMap
        },
        data() {
            return {
                options: [
                    {
                        name: "四大片区",
                        type: 1,
                        imgs: {
                            normal: ImageArea,
                            selected: ImageAreaSelected
                        },
                        isSelected: false
                    },
                    // {
                    //     name: "发展轴",
                    //     type: 3,
                    //     imgs: {
                    //         normal: ImageDevAxis,
                    //         selected: ImageDevAxisSelected
                    //     },
                    //     isSelected: false
                    // },
                    {
                        name: "创新平台",
                        type: 2,
                        imgs: {
                            normal: ImagePlatform,
                            selected: ImagePlatformSelected
                        },
                        isSelected: false
                    },
                    
                    {
                        name: "企业库",
                        type: 4,
                        imgs: {
                            normal: ImageEnterprise,
                            selected: ImageEnterpriseSelected
                        },
                        isSelected: false
                    }
                ]
            }
        },
        computed: {
            ...mapState(["tOption"])
        },
        created() {
            this.handleOptionClick(this.options[0]);
        },
        methods: {
            ...mapMutations(["updateTOption", "updateSelectedPlatform", "updateSelectedEnterprise"]),
            handleOptionClick(option) {

                option.isSelected = true;

                this.updateTOption(option);

                this.options.filter(opt => opt.name !== option.name).forEach(opt => {
                    opt.isSelected = false;
                });

                this.updateSelectedEnterprise(null);
                this.updateSelectedPlatform(null);
            }
        }
    }
</script>

<style lang="scss" scoped>

    .search-top-container {

        width: 100%;

        .search-top-btn-group {

            display: flex;
            flex-direction: row;
            align-items: flex-end;
            justify-content: space-between;
            height: 3rem;
            position: relative;

            .search-top-btn {
                width: 100%;
            }
        }
    }
</style>